import { useEffect, useState } from 'react';

/** How the winner's name is shown on stage. */
export const NAME_MODES = ['short', 'full', 'hidden'];

/** Stage framing for screen recording. ratio = width / height (null = fill the screen). */
export const FRAMES = {
  fill: { ratio: null },
  vertical: { ratio: 9 / 16 },
  horizontal: { ratio: 16 / 9 },
};

/** "Juan Pérez García" → full | "Juan P." | null */
export function formatWinnerName(name, mode) {
  const clean = String(name || '')
    .trim()
    .replace(/\s+/g, ' ');
  if (!clean || mode === 'hidden') return null;
  if (mode === 'full') return clean;
  const parts = clean.split(' ');
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1].charAt(0).toUpperCase()}.`;
}

export function hasWinner(premio) {
  return Boolean(premio && (premio.nroGanador || premio.ticketGanador));
}

/** Prizes come ordered last place → 1st from the API; keep that order defensively. */
export function sortForDraw(premios) {
  return [...(premios || [])].sort((a, b) => (Number(b.puesto) || 0) - (Number(a.puesto) || 0));
}

export function nextPendingPremio(premios) {
  return sortForDraw(premios).find(p => !hasWinner(p)) || null;
}

export function randomInt(max) {
  return Math.floor(Math.random() * max);
}

export function usePrefersReducedMotion() {
  const query = '(prefers-reduced-motion: reduce)';
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(query).matches
  );
  useEffect(() => {
    const mql = window.matchMedia?.(query);
    if (!mql) return undefined;
    const onChange = e => setReduced(e.matches);
    mql.addEventListener?.('change', onChange);
    return () => mql.removeEventListener?.('change', onChange);
  }, []);
  return Boolean(reduced);
}
